import VueTimeLine from './components/gant-board.vue'

export function install(Vue) {
    console.log('install');
    Vue.component('vue-timeline', VueTimeLine);
}
